import { P2GGrid, P2GText } from '@parcel2go/core-ui';
import ConnectedRefinementList from './ConnectedRefinementList';

interface ICustomRefinementList {
  attribute: string;
  limit: number;
  searchable: boolean;
  showMore: boolean;
}

const CustomRefinementList: React.FC<React.PropsWithChildren<ICustomRefinementList>> = ({
  children,
  attribute,
  ...rest
}) => (
  <P2GGrid container direction="column">
    <P2GGrid item>
      <P2GText variant="h6">{children}</P2GText>
    </P2GGrid>
    <ConnectedRefinementList attribute={attribute} {...rest} />
  </P2GGrid>
);

export default CustomRefinementList;
